import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "./style.scss"

const Web = () => {
  return (
    <div
      css={{
        backgroundColor: "#fff",
      }}
    >
      <div className="container">
        <div className="web m80-m30">
          <div className="title">
            <h3>网站建设</h3>
            <h4>WEBSITE DEVELOPMENT</h4>
          </div>
          <div
            className="row"
            css={{
              marginLeft: 0,
            }}
          >
            <div className="col-md-4 col-lg item pd0">
              <div className="row">
                <div className="col-3 col-md-12 pd0">
                  <div className="hex d-none d-md-block">
                    <a href="#">
                      <i></i>
                      <em></em>
                      <h4></h4>
                      <StaticImage
                        className="d-none d-md-block"
                        css={{
                          zIndex: 10,
                          margin: "0 auto",
                        }}
                        loading="lazy"
                        layout="fixed"
                        placeholder="blurred"
                        src="../../assets/images/企业网站.png"
                        quality={95}
                        formats={["AUTO", "WEBP", "AVIF"]}
                        alt="企业网站"
                        title="企业网站"
                      />
                    </a>
                  </div>
                  <div className="cir d-block d-md-none">
                    <StaticImage
                      className="d-block d-md-none"
                      css={{
                        margin: "0 auto",
                        top: 15,
                      }}
                      loading="lazy"
                      layout="fixed"
                      placeholder="blurred"
                      src="../../assets/images/企业网站.png"
                      quality={95}
                      width={40}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="企业网站"
                      title="企业网站"
                    />
                  </div>
                </div>
                <div className=" col-9 col-md-12">
                  <h5>企业网站</h5>
                  <p>企业门户官网/企业营销型网站定制开发，设计，建设</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg item pd0">
              <div className="row">
                <div className=" col-3 col-md-12 pd0">
                  <div className="hex d-none d-md-block">
                    <a href="#">
                      <i></i>
                      <em></em>
                      <h4></h4>
                      <StaticImage
                        className="d-none d-md-block"
                        css={{
                          zIndex: 10,
                          margin: "0 auto",
                        }}
                        loading="lazy"
                        layout="fixed"
                        placeholder="blurred"
                        src="../../assets/images/行业门户.png"
                        quality={95}
                        formats={["AUTO", "WEBP", "AVIF"]}
                        alt="行业门户"
                        title="行业门户"
                      />
                    </a>
                  </div>
                  <div className="cir d-block d-md-none">
                    <StaticImage
                      className="d-block d-md-none"
                      css={{
                        margin: "0 auto",
                        top: 10,
                      }}
                      loading="lazy"
                      layout="fixed"
                      placeholder="blurred"
                      src="../../assets/images/行业门户.png"
                      quality={95}
                      width={40}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="行业门户"
                      title="行业门户"
                    />
                  </div>
                </div>
                <div className="col-9 col-md-12">
                  <h5>行业门户</h5>
                  <p>垂直行业综合门户开发，资讯，交易，分类信息，下载等</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg item pd0">
              <div className="row">
                <div className=" col-3 col-md-12 pd0">
                  <div className="hex d-none d-md-block">
                    <a href="#">
                      <i></i>
                      <em></em>
                      <h4></h4>
                      <StaticImage
                        className="d-none d-md-block"
                        css={{
                          zIndex: 10,
                          margin: "0 auto",
                        }}
                        loading="lazy"
                        layout="fixed"
                        placeholder="blurred"
                        src="../../assets/images/购物商城.png"
                        quality={95}
                        formats={["AUTO", "WEBP", "AVIF"]}
                        alt="购物商城"
                        title="购物商城"
                      />
                    </a>
                  </div>
                  <div className="cir d-block d-md-none">
                    <StaticImage
                      className="d-block d-md-none"
                      css={{
                        margin: "0 auto",
                        top: 15,
                      }}
                      loading="lazy"
                      layout="fixed"
                      placeholder="blurred"
                      src="../../assets/images/购物商城.png"
                      quality={95}
                      width={40}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="购物商城"
                      title="购物商城"
                    />
                  </div>
                </div>
                <div className="col-9 col-md-12">
                  <h5>购物商城</h5>
                  <p>单/多用户商城，订单，支付，提现，财务管理</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg item pd0 offset-md-2 offset-lg-0">
              <div className="row">
                <div className=" col-3 col-md-12 pd0">
                  <div className="hex d-none d-md-block">
                    <a href="#">
                      <i></i>
                      <em></em>
                      <h4></h4>
                      <StaticImage
                        className="d-none d-md-block"
                        css={{
                          zIndex: 10,
                          margin: "0 auto",
                        }}
                        loading="lazy"
                        layout="fixed"
                        placeholder="blurred"
                        src="../../assets/images/活动官网.png"
                        quality={95}
                        formats={["AUTO", "WEBP", "AVIF"]}
                        alt="活动官网"
                        title="活动官网"
                      />
                    </a>
                  </div>
                  <div className="cir d-block d-md-none">
                    <StaticImage
                      className="d-block d-md-none"
                      css={{
                        margin: "0 auto",
                        top: 15,
                      }}
                      loading="lazy"
                      layout="fixed"
                      placeholder="blurred"
                      src="../../assets/images/活动官网.png"
                      quality={95}
                      width={40}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="活动官网"
                      title="活动官网"
                    />
                  </div>
                </div>
                <div className="col-9 col-md-12">
                  <h5>活动官网</h5>
                  <p>活动官方网站，信息发布，投票，报名，评比等</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg item pd0">
              <div className="row">
                <div className=" col-3 col-md-12 pd0">
                  <div className="hex d-none d-md-block ">
                    <a href="#">
                      <i></i>
                      <em></em>
                      <h4></h4>
                      <StaticImage
                        className="d-none d-md-block"
                        css={{
                          zIndex: 10,
                          margin: "0 auto",
                        }}
                        loading="lazy"
                        layout="fixed"
                        placeholder="blurred"
                        src="../../assets/images/外贸网站.png"
                        quality={95}
                        formats={["AUTO", "WEBP", "AVIF"]}
                        alt="外贸网站"
                        title="外贸网站"
                      />
                    </a>
                  </div>
                  <div className="cir d-block d-md-none">
                    <StaticImage
                      className="d-block d-md-none"
                      css={{
                        margin: "0 auto",
                        top: 15,
                      }}
                      loading="lazy"
                      layout="fixed"
                      placeholder="blurred"
                      src="../../assets/images/外贸网站.png"
                      quality={95}
                      width={40}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="外贸网站"
                      title="外贸网站"
                    />
                  </div>
                </div>
                <div className="col-9 col-md-12">
                  <h5>外贸网站</h5>
                  <p>企业出海必备，多语言，针对Google针对性优化</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Web
